const examActions = {
  GET_PROJECT_DETAILS : 'GET_PROJECT_DETAILS',
  SET_PROJECT_DETAILS : 'SET_PROJECT_DETAILS',
  GET_HEART_BEAT : 'GET_HEART_BEAT',
  SET_HEART_BEAT : 'SET_HEART_BEAT',
  GET_INSTRUCTIONS : 'GET_INSTRUCTIONS',
  SET_INSTRUCTIONS : 'SET_INSTRUCTIONS',
  GET_EXAM_QUESTIONS : 'GET_EXAM_QUESTIONS',
  SET_EXAM_QUESTIONS : 'SET_EXAM_QUESTIONS',
  SET_SUBMIT_ANSWER : 'SET_SUBMIT_ANSWER',
  GET_SUBMIT_ANSWER : 'GET_SUBMIT_ANSWER',
  AUDIT_LOG : 'AUDIT_LOG',
  END_EXAM : 'END_EXAM',
  ACTIVE_PING : 'ACTIVE_PING',
  GET_ACTION_RETRIEVE:'GET_ACTION_RETRIEVE',
  GET_EXAM_EVENTS : 'GET_EXAM_EVENTS',///////Broadcast events////
  SET_EXAM_EVENTS : 'SET_EXAM_EVENTS'
}

export default examActions;